"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _beforeMen = require("@/api/beforeMen/beforeMen");
var _public = require("@/api/public/public");
var _nav = require("@/api/nav/nav");
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'login',
  computed: _objectSpread({}, (0, _vuex.mapState)({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    }
  })),
  data: function data() {
    return {
      provinceId: this.$store.state.user.provinceId,
      isHome: 0,
      isNewsDetail: 0,
      businessId: '',
      isBack: false,
      loading: false,
      actNum: null,
      isEnter: true,
      opacity: "",
      codeImg: "",
      userLogin: {
        userHd: require("@/assets/img/user.png"),
        username: "登录"
      },
      logo: '',
      footerTxt: "",
      userMsg: {
        username: "",
        password: "",
        verificationCode: "",
        keyId: ""
      },
      // 登录框规则
      userRules: {
        username: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }, {
          min: 2,
          max: 18,
          message: "长度在 2 到 18 个字符",
          trigger: "blur"
        }, {
          required: true,
          pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
          message: "账号不支持特殊字符",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }
        // {
        //   min: 6,
        //   max: 16,
        //   message: "长度在 6 到 16 个字符",
        //   trigger: "blur"
        // }
        // {
        //   validator: passwordRule,
        //   trigger: "blur",
        // },
        ],
        verificationCode: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        }, {
          min: 4,
          max: 4,
          message: "长度在 4 个字符",
          trigger: "blur"
        }]
      },
      loginLogo: ""
    };
  },
  methods: {
    // 获取导航
    getNav: function getNav() {
      (0, _nav.navCode)({
        param: this.prCode
      }).then(function (res) {
        // this.navList = res.data;
      });
    },
    // 显示登录弹出框
    // 获取验证码
    getImgCode: function getImgCode() {
      var _this = this;
      (0, _public.getImgCode)().then(function (res) {
        _this.codeImg = "data:image/jpg;base64," + res.data.codeImage;
        _this.userMsg.keyId = res.data.keyId;
      });
    },
    // 设置flag
    setFlag: function setFlag() {
      (0, _public.webConfig)({
        param: this.prCode
      }).then(function (res) {
        var data = res.data;
        sessionStorage.setItem("book", JSON.stringify(data.expertAuthentication));
      });
    },
    // 登录
    login: function login(v) {
      var _this2 = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          var users = {
            username: _this2.userMsg.username,
            password: _this2.$md5(_this2.userMsg.password),
            realPassword: _this2.userMsg.password,
            code: _this2.userMsg.verificationCode,
            keyId: _this2.userMsg.keyId,
            urlSign: _this2.prCode
          };
          _this2.$store.dispatch("user/login", users).then(function (res) {
            _this2.loading = false;
            _this2.$router.push({
              path: "/dashboard",
              name: "Dashboard"
            });
            sessionStorage.setItem("isFlag", "true");
            _this2.$message.success("操作成功。");
            // this.setFlag();
          }).catch(function () {
            _this2.loading = false;
            _this2.$message.error("登录失败");
          });
        } else {
          return false;
        }
      });
    },
    // 前往后台
    backToHt: function backToHt() {
      this.$router.push({
        path: "/ht/dashboard",
        name: "Dashboard"
      });
    },
    // 获取网站标题logo,文字描述
    getWebLogo: function getWebLogo() {
      var _this3 = this;
      (0, _public.webConfig)({
        param: this.prCode
      }).then(function (res) {
        if (res.code === 2000) {
          var data = res.data;
          _this3.logo = data.webLogo;
          _this3.footerTxt = data.footer;
          _this3.loginLogo = data.loginLogo;
          // this.$store.commit('settings/getwTitle', data)
          _this3.getIndustry(); // 获取产业分类
          _this3.getIndustryCategory(); // 获取行业门类
          // this.getProjectLevel() // 获取项目级别
          _this3.getResourceType(); // 获取资源库类型
          _this3.getProfessionalResourceLibraryType(); // 获取资源库分类
          _this3.getCourseLevel(); // 获取层次管理
          _this3.getYearListAll(); // 获取层次管理
          _this3.getApplicationType(); // 获取应用类型
          _this3.getMediaType(); // 获取媒体类型
          _this3.getCourseSource(); // 获取课程来源
        }
      });
    },
    // 获取课程来源
    getCourseSource: function getCourseSource() {
      var _this4 = this;
      (0, _beforeMen.courseSource)({
        provinceId: this.provinceId
      }).then(function (res) {
        for (var i in res.data) {
          _this4.$set(res.data[i], "value", res.data[i].id);
        }
        _this4.$store.commit('settings/getwCourseSource', res.data);
      });
    },
    // 获取产业分类
    getIndustry: function getIndustry() {
      var _this5 = this;
      (0, _beforeMen.industryListAll)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this5.$store.commit('settings/getwIndustryType', res.data);
        // console.log('产业分类',this.$store.getters.wIndustryType)
      });
    },
    // 获取行业门类
    getIndustryCategory: function getIndustryCategory() {
      var _this6 = this;
      (0, _beforeMen.industryCategory)({
        provinceId: this.provinceId
      }).then(function (res) {
        // for(let i in res.data){
        //   res.data[i].name = res.data[i].remark + res.data[i].name
        // }
        _this6.$store.commit('settings/getwIndustryCategory', res.data);
      });
    },
    // 获取项目级别
    getProjectLevel: function getProjectLevel() {
      var _this7 = this;
      (0, _beforeMen.projectLevel)({
        provinceId: this.provinceId
      }).then(function (res) {
        for (var i in res.data) {
          _this7.$set(res.data[i], "value", res.data[i].id);
        }
        _this7.$store.commit('settings/getwProjectLevel', res.data);
      });
    },
    // 获取资源库类型
    getResourceType: function getResourceType() {
      var _this8 = this;
      (0, _beforeMen.resourceType)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this8.$store.commit('settings/getwResourceType', res.data);
      });
    },
    // 获取资源库分类
    getProfessionalResourceLibraryType: function getProfessionalResourceLibraryType() {
      var _this9 = this;
      (0, _beforeMen.professionalResourceLibraryType)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this9.$store.commit('settings/getwProfessionalResourceLibraryType', res.data);
      });
    },
    // 获取层次管理
    getCourseLevel: function getCourseLevel() {
      var _this0 = this;
      (0, _beforeMen.courseLevel)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this0.$store.commit('settings/getwCourseLevel', res.data);
      });
    },
    // 获取层次管理
    getYearListAll: function getYearListAll() {
      var _this1 = this;
      (0, _beforeMen.yearListAll)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this1.$store.commit('settings/getwYearListAll', res.data);
      });
    },
    // 获取应用类型
    getApplicationType: function getApplicationType() {
      var _this10 = this;
      (0, _beforeMen.applicationType)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this10.$store.commit('settings/getwApplicationType', res.data);
      });
    },
    // 获取媒体类型
    getMediaType: function getMediaType() {
      var _this11 = this;
      (0, _beforeMen.mediaType)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this11.$store.commit('settings/getwMediaType', res.data);
      });
    },
    // 获取专业大类
    getMajor: function getMajor() {
      var _this12 = this;
      (0, _beforeMen.getMatchMajorListAll)({
        businessId: "",
        parentId: '0'
      }).then(function (res) {
        if (res.code === 2000) {
          _this12.$store.commit('settings/getwMajorListAll', res.data);
          console.log('专业大类', _this12.$store.getters.wMajorListAll);
        }
      });
    }
  },
  created: function created() {
    // this.getImgCode();
    // // 获取导航
    // // this.getNav();
    // // 本地存储导航样式下标
    // sessionStorage.setItem("actNum", this.actNum);
    // // 判断状态
    // let e = sessionStorage.getItem("info");
    // if (e) {
    //   this.isBack = true;
    //   this.userLogin.userHd = JSON.parse(e).avatarUrl;
    // } else {
    //   this.isBack = false;
    // }
  }
};